
































































































































































































































































































import moment from 'moment';
import {
  IRequisition,
  IRequisitionLine,
  RequisitionStatusEnum
} from '@/models';
import { DataTableHeader } from 'vuetify';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';

export default mixins(auth).extend({
  name: 'RequisitionDetail',

  components: {
    DetailOptionsButton
  },

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    }
  },

  computed: {
    canEditAllRequisitionLine() {
      return this.requisition.status.value === RequisitionStatusEnum.Draft;
    },

    headers() {
      const baseHeaders: DataTableHeader[] = [
        {
          text: '#',
          value: 'index',
          width: 45,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Item',
          value: 'item',
          width: 300,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },

        {
          text: 'Account',
          value: 'account',
          width: 100,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Department',
          value: 'department',
          sortable: false,
          width: 100,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'UOM',
          value: 'uom',
          sortable: false,
          width: 70,
          align: 'center',
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Quantity',
          value: 'quantity',
          align: 'center',
          sortable: false,
          width: 90,
          class: 'primary white--text subtitle-1 min-td'
        },
        {
          text: 'Unit Price',
          value: 'unit_price',
          align: 'center',
          width: 100,
          sortable: false,

          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Subtotal',
          value: 'total_price',
          align: 'center',
          width: 150,
          sortable: false,
          class: 'primary white--text subtitle-1'
        }
      ];

      if (this.userHasRoles(['Finance Vice President'])) {
        baseHeaders.push({
          text: '',
          value: 'actions',
          align: 'center',
          width: 10,
          sortable: false,
          class: 'primary white--text subtitle-1'
        });
      }

      return baseHeaders;
    }
  },

  methods: {
    momentFormat(date: Date | string | number, days = 0) {
      return moment(date)
        .add(days, 'd')
        .format('LL')
        .toString();
    },

    editRequisitionLine(item: IRequisitionLine) {
      this.$emit('edit-requisition-line', item);
    }
  }
});
